module.exports = __webpack_public_path__ + "img/tsc.aaacafe.png";